function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function Svg130Australia(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#0052B4"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "128,307.482 141.697,336.124 172.63,328.974 158.778,357.542 183.652,377.268    152.682,384.248 152.767,415.997 128,396.134 103.233,415.997 103.319,384.248 72.348,377.268 97.223,357.542 83.37,328.974    114.303,336.124  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "387.844,343.989 394.378,357.65 409.131,354.241 402.524,367.865 414.389,377.275    399.617,380.604 399.658,395.747 387.844,386.273 376.032,395.747 376.073,380.604 361.301,377.275 373.166,367.865    366.557,354.241 381.312,357.65  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "327.066,199.066 333.599,212.728 348.353,209.317 341.747,222.943 353.611,232.352    338.838,235.681 338.878,250.824 327.066,241.35 315.253,250.824 315.294,235.681 300.522,232.352 312.386,222.943    305.779,209.317 320.532,212.728  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "387.844,116.253 394.378,129.914 409.131,126.504 402.525,140.13 414.389,149.538    399.617,152.869 399.658,168.011 387.844,158.537 376.032,168.011 376.073,152.869 361.301,149.538 373.165,140.13    366.557,126.504 381.312,129.914  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "440.934,178.363 447.468,192.024 462.221,188.614 455.614,202.24 467.478,211.649    452.706,214.978 452.747,230.121 440.934,220.646 429.122,230.121 429.162,214.978 414.389,211.649 426.253,202.24    419.646,188.614 434.401,192.024  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "402.973,250.824 408.112,266.641 424.742,266.641 411.287,276.415 416.426,292.231    402.973,282.456 389.518,292.231 394.657,276.415 381.204,266.641 397.833,266.641  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "256,0 256,48.896 215.853,89.043 256,89.043 256,166.957 203.464,166.957 256,219.492    256,256 232.281,256 166.957,190.664 166.957,256 89.043,256 89.043,178.276 11.331,256 0,256 0,207.104 40.147,166.957 0,166.957    0,89.043 52.536,89.043 0,36.508 0,0 23.719,0 89.043,65.336 89.043,0 166.957,0 166.957,77.724 244.669,0  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "0,152.001 103.999,152.001 104.001,256 152.001,256 152.001,152.001 256,152.001   256,104.001 151.999,104.001 152.001,0 104.001,0 104.001,104.001 0,104.001 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "166.957,166.957 256,256 256,230.82 192.137,166.957 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "166.957,166.957 256,256 256,230.82 192.137,166.957 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "166.957,166.957 256,256 256,230.82 192.137,166.957  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "63.862,166.959 0,230.821 0,256 0,256 89.041,166.959  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "89.043,89.043 0,0 0,25.18 63.863,89.043 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "89.043,89.043 0,0 0,25.18 63.863,89.043 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "89.043,89.043 0,0 0,25.18 63.863,89.043  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "192.138,89.041 256,25.179 256,0 256,0 166.959,89.041  "
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg130Australia);
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };